"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var ratingToDisplay = function ratingToDisplay(ratings) {
  var sortOrder = ['Responsiveness', 'Price', 'Quality', 'Punctuality', 'Professionalism'];
  if (ratings.length > 0) {
    var eligibleRatings = (0, _filter["default"])(ratings).call(ratings, function (rating) {
      return rating.name !== 'Overall' && (0, _includes["default"])(sortOrder).call(sortOrder, rating.name) && rating.starRating >= 4.0;
    });
    var sortedRatings = (0, _sort["default"])(eligibleRatings).call(eligibleRatings, function (r1, r2) {
      return (0, _indexOf["default"])(sortOrder).call(sortOrder, r1.name) - (0, _indexOf["default"])(sortOrder).call(sortOrder, r2.name);
    });
    return sortedRatings.length > 0 ? sortedRatings[0] : undefined;
  }
  return undefined;
};
var _default = exports["default"] = ratingToDisplay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/utils/ratingUtils.js
// module id = 6299
// module chunks = 25